import { useContext, useEffect, useState } from "react";
import RorpContext from "../contexts/RorpContext";
import isSSR from "./isSSR";

// In this custom hook, "location" refers to the window location, or URL. We extract search params
// from the query string, for example ?size=small. In the client, we can use the useLocation()
// hook provided by react-router-dom, but on the server, that will not work. Instead, we can get
// the location from the RubyOnRailsPro context (RorpContext). We should make sure we
// always provide a RorpContext to our components. Note: if / when we
// migrate off RORP, we can simply replace the location lookup with a server/client-friendly
// equivalent means of finding location in whatever replacement system we go with (Next.js etc)

const useLocationSearch = () => {
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    const handleLocationChange = () => {
      setSearch(window.location.search);
    };

    if (!isSSR()) {
      handleLocationChange();
      window.addEventListener("popstate", handleLocationChange);
      window.addEventListener("pushstate", handleLocationChange);
      window.addEventListener("replacestate", handleLocationChange);
    } else {
      const context = useContext(RorpContext);
      if (context) {
        setSearch(context.location.search);
      } else {
        throw new Error("RorpContext is not provided");
      }
    }

    return () => {
      if (!isSSR()) {
        window.removeEventListener("popstate", handleLocationChange);
        window.removeEventListener("pushstate", handleLocationChange);
        window.removeEventListener("replacestate", handleLocationChange);
      }
    };
  }, []);

  return search;
};

export default useLocationSearch;
